{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
{{#each options}}
  <dd>
    <input type="radio" name="{{../prefix}}[{{../name}}]" {{#if ../testIdPrefix}}data-testid="{{../testIdPrefix}}-{{dasherize ../name}}"{{/if}} {{#unless @index}}checked{{/unless}} id="{{../id}}_{{parameterize this}}" value="{{this}}" {{#if ../required}}required{{/if}} />
    <label for="{{../id}}_{{parameterize this}}">{{this}}</label>
  </dd>
{{/each}}
